import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => {
  return step.description;
};

export const getDescription = ({ step: { details }, metaData, t }) => {
  const inputs = details.inputs || [];
  const outputs = details.outputs || [];

  const description = t(
    'Run {{runtime}} Code on ({{input}}{{restInputsCount}}) and set ({{output}}{{restOutputsCount}})',
    {
      runtime:
        (metaData?.code_runners.runtime_choices || []).find(
          ({ value }) => value === details.runtime
        )?.label || t('Unknown Runtime'),
      input: inputs[0]?.name ?? t('0 inputs'),
      restInputsCount:
        inputs.length > 1
          ? t(', and {{N}} more', {
              N: inputs.length - 1,
            })
          : '',
      output: outputs[0]?.name ?? t('0 outputs'),
      restOutputsCount:
        outputs.length > 1
          ? t(', and {{N}} more', {
              N: outputs.length - 1,
            })
          : '',
    }
  );

  return description;
};

export default function CodeStepCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
